<div class="row">
  <div class="col-lg-12 text-center">
    <h2 class="section-heading">Inquire About This Property</h2>
    <h3 class="section-subheading text-muted">Please fill out the form below.</h3>
  </div>
</div>
<div *ngIf="!hiddenBln" class="row">
  <div class="col-lg-12">
    <form [formGroup]="contactForm" #formDir="ngForm">
      <div *ngIf="successBln" class='alert alert-success'>
        <span id="rental-enquiry-success">
          <button type='button' class='close' data-dismiss='alert' aria-hidden='true'
                  (click)="hideForm()">
            <span aria-hidden="true">×</span>
          </button>
          <strong>Your message has been sent. </strong>
        </span>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input id="name" class="form-control" placeholder="Your name *"
                   formControlName="name" required>

            <div *ngIf="isNameInvalid() && (isNameDirty() || isNameTouched())"
                 class="alert alert-danger">
              <div *ngIf="hasError('name', 'required')">
                Please enter your name.
              </div>
              <div *ngIf="hasError('name', 'minlength')">
                Name must be at least 4 characters long.
              </div>
            </div>
          </div>
          <div class="form-group">
            <input id="email" class="form-control" placeholder="Your Email *"
                   formControlName="email" required>

            <div *ngIf="isEmailInvalid() && (isEmailDirty() || isEmailTouched())"
                 class="alert alert-danger">
              <div *ngIf="hasError('email', 'required')">
                Please enter your email address.
              </div>
              <div *ngIf="hasError('email', 'email')">
                Please enter a valid email address.
              </div>
            </div>
          </div>
          <div class="form-group">
            <input id="phone" class="form-control" placeholder="Your Phone *"
                   formControlName="phone" required>

            <div *ngIf="isPhoneInvalid() && (isPhoneDirty() || isPhoneTouched())"
                 class="alert alert-danger">
              <div *ngIf="hasError('phone', 'required')">
                Please enter your phone number.
              </div>
              <div *ngIf="hasError('phone', 'minlength')">
                Phone must be at least 4 characters long.
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <textarea class="form-control" placeholder="Your Message *" id="message"
                      formControlName="message" required></textarea>

            <div *ngIf="isMessageInvalid() && (isMessageDirty() || isMessageTouched())"
                 class="alert alert-danger">
              <div *ngIf="hasError('message', 'required')">
                Message is required.
              </div>
              <div *ngIf="hasError('message', 'minlength')">
                Message must be at least 4 characters long.
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="col-lg-12 text-center">
          <div id="success"></div>
          <div [hidden]="isFormSubmitted">
            <button type="submit" class="btn btn-xl"
                    [disabled]="contactForm.invalid"
                    (click)="submitContactForm()">
              Send Message
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
